import { forwardRef } from "react";

import { cn } from "../index";

interface LoaderProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: number;
}

const Loader = forwardRef<HTMLDivElement, LoaderProps>(({ size = 32, style, className, ...props }, forwardedRef) => {
  const sizeValue = `${size}px`;

  return (
    <div
      {...props}
      ref={forwardedRef}
      className={cn("animate-loader-rotation relative block h-(--loader-size) w-(--loader-size)", className)}
      style={{ ...style, ["--loader-size" as string]: sizeValue }}
    >
      <span
        className={cn(
          "animate-loader-inner inset-0 absolute m-auto block h-(--loader-size) w-(--loader-size)",
          "[clip:rect(calc(var(--loader-size)/2),var(--loader-size),var(--loader-size),0)]",
        )}
      >
        <span
          className={cn(
            "animate-loader-border inset-0 absolute m-auto box-border h-(--loader-size) w-(--loader-size) rounded-full border-[3px] border-transparent border-t-primary-blue",
          )}
        />
        <span
          className="inset-0 absolute m-auto box-border h-(--loader-size) w-(--loader-size) rounded-full border-[3px]"
          style={{ borderColor: "rgba(17, 0, 250, 0.5)" }}
        />
      </span>
    </div>
  );
});

export default Loader;
export { Loader };
export type { LoaderProps };
